import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { jsonAuthHeaders } from "@/utils/headers";
import { ENDPOINTS } from "@/api/application-api";
import { useInvalidateFolderEntitiesForEntity } from "@/queries/folder-entities/useInvalidateFolderEntitiesForEntity";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { displayErrorToast } from "@/utils/toast";

export const useEditDatasetGroup = (userToken: string, folder_id?: number | null) => {
  const queryClient = useQueryClient();
  const { workspaceId } = useParams();
  const invalidateFolderEntities = useInvalidateFolderEntitiesForEntity();

  return useMutation(
    ({
      datasetGroupId,
      name,
      tags,
    }: {
      datasetGroupId: number;
      name?: string;
      tags?: string[];
    }) => {
      const body: Record<string, unknown> = {};
      if (name !== undefined) {
        body.name = name;
      }
      if (tags !== undefined) {
        body.tags = tags;
      }
      return fetch(`${ENDPOINTS.dataset_groups}/${datasetGroupId}`, {
        method: "PATCH",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify(body),
      }).then(handleResponse);
    },
    {
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries([ENDPOINTS.dataset_groups]);
        invalidateFolderEntities(folder_id ?? null);

        queryClient.invalidateQueries([
          "changelog",
          workspaceId,
          variables.datasetGroupId,
          "DATASET",
        ]);
        queryClient.invalidateQueries(["global-changelog", workspaceId]);
      },
      onError: () => {
        displayErrorToast("Failed to update dataset group name");
      },
    },
  );
};
